export const INFO_MODAL_TYPES = {
  TUTORIAL: "tutorial",
  TERMS: "terms-of-use",
  PRIVACY: "privacy-policy"
} as const

export type TInfoModalType =
  (typeof INFO_MODAL_TYPES)[keyof typeof INFO_MODAL_TYPES]

export interface IInfoModalHasReadDto {
  type: TInfoModalType
  lang: string
}

export interface IInfoModalHasRead {
  hasRead: boolean
}

export interface IMarkInfoModalAsReadDto {
  type: TInfoModalType
  lang: string
}
